import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getSubPackageById,
  updateSubPackage,
} from "../../services/subPackages";
import SubPackageForm from "./components/SubPackageForm";
import { toast } from "react-toastify";

const EditSubPackage = () => {
  const { state } = useLocation();
  const id = state?.id;
  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);

  const getData = useCallback(async () => {
    const resp = await getSubPackageById({ id: id });
    const { data, status } = resp;
    console.log("status", status,"data", data);
    
    if (status === 200) {
      setData(data?.data);
    }
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const initialValues = {
    name: data?.name ?? "",
    image: data?.image ?? "",
    description: data?.description ?? "",
    rating: data?.rating ?? 0,
    label: data?.label ?? "",
    status: data?.status ?? "",
    days: data?.days ?? 0,
    nights: data?.nights ?? 0,
    price: data?.price ?? 0,
    discountPrice: data?.discountPrice ?? 0,
    itinerary: data?.itinerary ?? [],
    inclusions: data?.inclusions?.map((el) => ({ content: el })) ?? [],
    exclusions: data?.exclusions?.map((el) => ({ content: el })) ?? [],
    package_id: data?.package_id ?? "",
  };

  const handleUpdateSubPackage = async (values, { resetForm }) => {
    const inputs = {
      id: id,
      ...values,
      inclusions: values?.inclusions?.map((el) => el.content),
      exclusions: values?.exclusions?.map((el) => el.content),
    };

    const res = await updateSubPackage(inputs);

    if (res?.status === 200) {
      setLoader(false);
      resetForm({});
      toast.success(res?.data?.message);
    } else {
      setLoader(false);
    }
  };
  return (
    <SubPackageForm
      initialValues={initialValues}
      isUpdate={true}
      loader={loader}
      handleSubmit={handleUpdateSubPackage}
    />
  );
};

export default EditSubPackage;
